const ATTR_REGEX = /([a-z0-9_-]+)="([^"]*)"/gim;
export function getParams(str) {
  return Object.fromEntries(new URLSearchParams(str).entries());
}
export function mergeSvgAttributes(svg, attrs) {
  return svg.replace(/<svg([^>]*)>/i, (_match, existingAttrs) => {
    if (attrs["size"]) {
      attrs["width"] = attrs["size"];
      attrs["height"] = attrs["size"];
      delete attrs["size"];
    }
    const map = /* @__PURE__ */ new Map();
    for (const [, name, value] of (existingAttrs ?? "").matchAll(ATTR_REGEX)) {
      map.set(name, value);
    }
    for (const [k, v] of Object.entries(attrs)) {
      if (k === "class" && map.has("class")) {
        map.set("class", map.get("class") + " " + v);
      } else if (k === "style" && map.has("style")) {
        map.set("style", map.get("style") + ";" + v);
      } else {
        map.set(k, v);
      }
    }
    const merged = [...map.entries()].map(([k, v]) => `${k}="${v}"`).join(" ");
    return `<svg ${merged}>`;
  });
}
export function getResizer(base, params) {
  const cache = {};
  return function getIcon(size, attrs = {}) {
    const attributes = {
      ...getParams(params),
      ...attrs,
      height: size.toString(),
      width: size.toString()
    };
    return cache[JSON.stringify(attributes)] ??= mergeSvgAttributes(base, attributes);
  };
}